import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { adwTransferFiles } from "../../data-wrangler/dataWranglerSlice";
import { Button, IconButton, Stack, Typography, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { colours } from "../../../StyleConstants";
import React from "react";
import LassoModal from "../../../components/LassoModal";

interface props {
    open: boolean,
    setOpen: Function,
}

const ToolSelectModal = (props: props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const linkDownloadClient = "/download-tools";
    const linkGlobusDocumentation = window.env.globusDocumentation;
    const cliQueryDownloadClientEnabled = window.env.cliQueryDownloadClientEnabled ?? false;

    const onSubmitGlobus = () => {
        dispatch(adwTransferFiles());
        props.setOpen(false)
        navigate("/globus-collections");
    }

    return (
        <LassoModal open={props.open}>
            <Stack gap={3}>
                <Stack
                    flexDirection="column"
                    gap={3}
                    height="100%"
                >
                    <Stack flexDirection="row" justifyContent="space-between" alignItems="center">
                        {!cliQueryDownloadClientEnabled ?
                            <Box textAlign="center" sx={{ width: '100%' }}>
                                <Typography fontSize="1.5rem" fontWeight={600} textAlign="center">Globus Share</Typography>
                            </Box>
                            :
                            <Typography margin="auto" fontSize="1.5rem" fontWeight={600} textAlign="center">Select a Transfer Method</Typography>
                        }
                        <IconButton
                            aria-label="close"
                            onClick={() => {props.setOpen(false)}}
                            sx={{
                                width: '24px',
                                height: '24px',
                            }}
                        >
                            <CloseIcon/>
                        </IconButton>
                    </Stack>

                    <Stack flexDirection="row" gap={3} justifyContent="space-between">
                        {!cliQueryDownloadClientEnabled ?
                            <Stack sx={{ width: '100%' }} justifyContent="space-between" gap={3}>
                                <Typography textAlign="center">
                                    Transfer the data through your institution's secure Globus Share. You must first have a
                                    Globus account and share setup. To learn how to setup your Globus account you can consult
                                    this <a href={linkGlobusDocumentation} target="_blank" rel="noopener noreferrer">documentation.</a>
                                </Typography>
                                <Button onClick={onSubmitGlobus} variant="secondary" sx={{ alignSelf: "center" }}>
                                    Continue
                                </Button>
                            </Stack>
                            :
                            <>
                                <Stack sx={{ width: '50%' }} justifyContent="space-between" gap={3}>
                                    <Stack flexDirection="row" justifyContent="center" alignItems="center">
                                        <Typography textAlign="center" fontWeight={600} fontSize="1.25rem" component="h3">
                                            Globus Share&nbsp;
                                            <Box
                                                component="span"
                                                display="inline"
                                                lineHeight="inherit"
                                                fontSize="0.875rem"
                                                color={colours.success.success}
                                            >
                                                (Recommended)
                                            </Box>
                                        </Typography>
                                    </Stack>
                                    <Typography textAlign="center">
                                        Transfer the data through your institution’s secure Globus Share. You must first have a
                                        Globus account and share setup. To learn how to setup your Globus account you can consult
                                        this <a href={linkGlobusDocumentation} target="_blank" rel="noopener noreferrer">documentation.</a>
                                    </Typography>
                                    <Button onClick={onSubmitGlobus} variant="secondary" sx={{ alignSelf: "center" }}>
                                        Select
                                    </Button>
                                </Stack>

                                <Stack sx={{ width: '50%' }} justifyContent="space-between" gap={3}>
                                    <Stack flexDirection="row" justifyContent="center" alignItems="center">
                                        <Typography textAlign="center" fontWeight={600} fontSize="1.25rem" component="h3">
                                            Lasso Download Client&nbsp;
                                            <Box
                                                component="span"
                                                display="inline"
                                                lineHeight="inherit"
                                                fontSize="0.875rem"
                                                color={colours.warning.warn}
                                            >
                                                (Beta)
                                            </Box>
                                        </Typography>
                                    </Stack>
                                    <Typography textAlign="center">
                                        Installed on your local machine, the Lasso client allows you to manage all your transfers
                                        from the platform in one streamline tool. You must first install the transfer
                                        tool <a href={linkDownloadClient}>available here.</a>
                                    </Typography>
                                    <Button variant="secondary" sx={{ alignSelf: "center" }} disabled>
                                        Coming Soon!
                                    </Button>
                                </Stack>
                            </>
                        }
                    </Stack>
                </Stack>
            </Stack>
        </LassoModal>
    )
}

export default ToolSelectModal